export default function Banner() {
  return (
    <section className="bg-plum py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
          Votre fenêtre ferme mal ou se bloque ?
        </h2>
        <p className="text-rose-100 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-8 leading-relaxed">
          Dans <span className="text-coral font-bold">90% des cas</span>, on répare le mécanisme sans changer la fenêtre.
        </p>
        <a
          href="tel:0374471036"
          className="inline-flex items-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base md:text-lg whitespace-nowrap hover:bg-coral-light transition-colors shadow-lg shadow-coral/20"
        >
          Diagnostic gratuit — 03 74 47 10 36
          <i className="ri-arrow-right-line" />
        </a>
        {/* Brand logos */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10 opacity-60">
          {["Ferco", "GU", "Roto", "Maco", "Siegenia"].map((brand) => (
            <span key={brand} className="text-white/80 font-semibold text-sm md:text-base tracking-wider">
              {brand}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}